import React from 'react';
import { Hero } from '../components/home/Hero';
import { TrustBar } from '../components/home/TrustBar';
import { PickYourSport } from '../components/home/PickYourSport';
import { WhyChoosePts } from '../components/home/WhyChoosePts';
import { OrderProcess } from '../components/home/OrderProcess';
import { TeamPackages } from '../components/home/TeamPackages';
import { TeamStoresSection } from '../components/home/TeamStoresSection';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { FinalCta } from '../components/home/FinalCta';
export function Home() {
  return <div className="w-full" data-id="element-516">
      <Hero data-id="element-517" />
      <TrustBar data-id="element-518" />
      <PickYourSport data-id="element-519" />
      <WhyChoosePts data-id="element-520" />
      <OrderProcess data-id="element-521" />
      <TeamPackages data-id="element-522" />
      <TeamStoresSection data-id="element-523" />
      <ReviewsSection data-id="element-524" />
      <FinalCta data-id="element-525" />
    </div>;
}